import { ItemCombobox } from '@models-global/model-combobox-item';
export const ENUM_ENTITY_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
  PENDING: 2,
  REJECTED: 3,
  APPROVED: 4
} as const;

export const ARRAY_ENTITY_STATUS: ReadonlyArray<ItemCombobox> = [
  { value: ENUM_ENTITY_STATUS.ACTIVE, text: 'Active' },
  { value: ENUM_ENTITY_STATUS.INACTIVE, text: 'Inactive' },
  { value: ENUM_ENTITY_STATUS.PENDING, text: 'Pending' },
  { value: ENUM_ENTITY_STATUS.REJECTED, text: 'Rejected' },
  { value: ENUM_ENTITY_STATUS.APPROVED, text: 'Approved' }
];

export const MAP_ENTITY_STATUS = {
  [ENUM_ENTITY_STATUS.ACTIVE]: 'Active',
  [ENUM_ENTITY_STATUS.INACTIVE]: 'Inactive',
  [ENUM_ENTITY_STATUS.PENDING]: 'Pending',
  [ENUM_ENTITY_STATUS.REJECTED]: 'Rejected',
  [ENUM_ENTITY_STATUS.APPROVED]: 'Approved'
};
